module.exports = __webpack_public_path__ + "static/media/hotspots_icons.235b005b.png";